<div class="tabWrapper">
    <ng-content select=".preTab" />

    @if (!hideTabsNavigation()) {
        <app-tab-header #tabHeader>
            @for (tab of tabs; track tab.label; let index = $index) {
                <span
                    class="tab"
                    [ngClass]="{ highlighted: tab.highlighted, active: selectedTabIndex === index, disabled: tab.disabled }"
                    (click)="tabSelectHandler(index)"
                    *appPermission="tab.permissionLabel ?? 'appPermissionAlwaysShow'"
                >
                    @if (tab.icon) {
                        <i [class]="tab.icon"></i>
                    }
                    {{ tab.label | translate }}
                </span>
            }
        </app-tab-header>
    }

    <ng-content select=".postTab" />
</div>

<div class="tabContentContainer">
    <ng-content select=".preContent" />
    @if (showRestrictiveUiInfoNotification()) {
        <ng-template [ngTemplateOutlet]="restrictiveUiInfoNotification"> </ng-template>
    }
    <ng-container #tabContentContainer />
    <ng-content select=".postContent" />
</div>

<ng-template #restrictiveUiInfoNotification>
    <div class="infoNotification warning">
        <i class="fa-solid fa-warning"></i>
        <span class="label"
            >{{ 'listings.userPreferences.restrictiveUi.infoNotification' | translate
            }}{{ restrictiveUiChannel() ? ': ' + restrictiveUiChannel()?.label : '.' }}
        </span>
    </div>
</ng-template>
